

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {

      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.formContainer = this.querySelector('[data-form-container]');

        this.handleViewProduct();
      }

      get productForm() {
        return this.formContainer.querySelector(`product-form`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      pushViewItem() {
        const productHandle = this.dataset.handle;
        if (!productHandle) return;

        const stack = JSON.parse(localStorage.getItem('viewedProducts')) || [];
        const index = stack.indexOf(productHandle);

        if (index > -1) stack.splice(index, 1);
        stack.unshift(productHandle);

        localStorage.setItem('viewedProducts', JSON.stringify(stack));
      }

      handleViewProduct() {
        this.pushViewItem();

        const trackingProduct = this.querySelector('[data-tracking-product]');
        if (!trackingProduct) 
          return;

        const item = JSON.parse(trackingProduct.innerHTML);
        publish(PUB_SUB_EVENTS.onGenericTrackEvent, {
          events: [
            [
              'track', 'Viewed Product', item
            ],
            [
              'trackViewedItem', {
                Title: item.name,
                ItemId: item.productID,
                Categories: item.Categories,
                ImageUrl: item.ImageURL,
                Url: item.URL,
                Metadata: {
                  Brand: item.Brand,
                  Price: item.Price,
                  CompareAtPrice: item.CompareAtPrice
                }
              }
            ]
          ]
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        const type = event.target.closest('variant-selects')?.dataset.type;
        const productUrl = target.dataset.productUrl || this.dataset.url;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
          callback: type  ? this.handleUpdateBikiniInfo(type): this.handleUpdateProductInfo(productUrl)
        });
      }

      async renderProductInfo({ requestUrl, callback }) {
        const response = await fetch(requestUrl);
        const responseText = await response.text();

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        callback(html);
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = ProductUtils.getSelectedVariant(html.querySelector('product-info'));

          this.pickupAvailability?.update(variant);
          this.updateURL(productUrl, variant?.id);

          ProductUtils.updateVariantInputs(this.querySelector('[data-form-container]'), variant?.id, {
            callback: (input) => input.dispatchEvent(new Event('change', { bubbles: true }))
          });

          const sections = [
            '[data-buy-buttons]',
            `#price-${this.sectionId}`,
            '[data-selected-option]'
          ];

          for (let section of sections)
            ProductUtils.updateSource(this, html, section, true);


          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

        };
      }

        handleUpdateBikiniPrice(priceSelector, html) {
            const priceOnSaleElement = html.querySelector(`#price-${this.sectionId} .price__sale`);
            const priceRegularElement = html.querySelector(`#price-${this.sectionId} .price__regular`);

            const regularPrice = priceOnSaleElement.querySelector(".price-item--regular")?.textContent.trim();
            const salePrice = priceOnSaleElement.querySelector(".price-item--sale")?.textContent.trim();

            this.querySelector(priceSelector).innerHTML = (regularPrice === salePrice)
                ? priceRegularElement?.innerHTML || ''
                : priceOnSaleElement.innerHTML;
        }


        handleUpdateBikiniInfo(type) {
          return (html) => {
              const variant = ProductUtils.getSelectedVariant(html.querySelector('product-info'));

              ProductUtils.updateVariantInputs(this, variant?.id, {
                selector: `input[data-${type.toLowerCase()}-input]`
              });

              const priceSelector = `variant-selects[data-type=${type}] span[data-price]`;
              const optionSelector = `variant-selects[data-type=${type}] span[data-selected-option]`;
              this.handleUpdateBikiniPrice(priceSelector,html);
              this.querySelector(priceSelector).classList.remove('tw-hidden');

              this.querySelector(optionSelector).innerHTML = html.querySelector(`variant-selects[data-type] span[data-selected-option]`).innerHTML;
              this.querySelector(optionSelector).classList = html.querySelector(`variant-selects[data-type] span[data-selected-option]`).classList;

              ProductUtils.updateSource(this, html, '.product-form__buttons');

              publish(PUB_SUB_EVENTS.variantChange, {
                  data: {
                      sectionId: this.sectionId,
                      html,
                      variant,
                  },
              });
          };

      }

      buildRequestUrlWithParams(url, optionValues) {
        const params = [];
        params.push(`section_id=${this.sectionId}`)

        if (optionValues.length)
          params.push(`option_values=${optionValues.join(',')}`);

        return `${url}?${params.join('&')}`;
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

    }
  );
}

